enum AppEventSourceHostType {
  windowsApp,
  webApp
}

export default AppEventSourceHostType;
